import { IPopularCollection } from '@modules/collections/domain/models/popularCollection.model';
import { IGetPopularCollectionUsecase } from '@modules/collections/domain/ports/getPopularCollection.usecase.port';
import { left, right } from '@shared/utils/either.utils';
import { shuffleArrayWithLimitOutput } from '@shared/utils/random.utils';
import { IPopularCollectionRepository } from '../ports/popularCollection.repository.port';
export class GetPopularCollectionUsecase implements IGetPopularCollectionUsecase {
  constructor(private readonly popularCollectionRepository: IPopularCollectionRepository) {}
  async handle(): IGetPopularCollectionUsecase.getPopularCollectionOutput {
    const result = await this.popularCollectionRepository.getPopularCollection();
    const value = result.value;
    if (result.isLeft()) return left([]);
    const output: IPopularCollection[] = value.map((popularCollection: IPopularCollection) => {
      return {
        ...popularCollection,
        recipeList: shuffleArrayWithLimitOutput(popularCollection.recipeList, 4)
      };
    });
    return right(output);
  }
}